const ITEMS = [
  "Interior Architecture",
  "Bespoke Furniture",
  "Turnkey Execution",
  "Material Curation",
  "Lighting Design",
  "Hyderabad · India",
];

function List({ ariaHidden }) {
  return (
    <ul
      aria-hidden={ariaHidden || undefined}
      className="flex shrink-0 items-center"
    >
      {ITEMS.map((item, i) => (
        <li key={i} className="flex shrink-0 items-center">
          <span className="font-serif italic text-2xl sm:text-3xl text-bronze px-6 sm:px-10 whitespace-nowrap">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/60" aria-hidden="true" />
        </li>
      ))}
    </ul>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-bronze/15 bg-sand py-5 sm:py-6"
    >
      <div className="animate-marquee flex w-max">
        <List />
        <List ariaHidden />
      </div>
    </div>
  );
}
